import { render, staticRenderFns } from "./ProductFormGroup.vue?vue&type=template&id=cdbcebd6&scoped=true&"
import script from "./ProductFormGroup.vue?vue&type=script&lang=js&"
export * from "./ProductFormGroup.vue?vue&type=script&lang=js&"
import style0 from "./ProductFormGroup.vue?vue&type=style&index=0&id=cdbcebd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdbcebd6",
  null
  
)

export default component.exports